import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Button from '../../../components/Button/Button';
import styles from './price.module.scss';
import { useNavigate } from 'react-router-dom';
import { addPointsInText, removePointsInText } from '../../../helpers/app';
import { PriceProps } from '../../../interfaces/salePost';
import { YesNoTypes } from '../../../interfaces/types';
import PriceContainer from '../../../containers/Sell/PriceContainer';
import {images} from '../../../constants/images';

const Price = ({
  vehiclePaid,
  setIsPaid,
  negotiatePrice,
  setIsNegotiate,
  setSuggestedPrices,
  suggestedPrices,
  fetchingSuggedtedPrices,
  fetchingAdditionalCost,
  additionalCost,
  setPrice,
  price,
  user,
  setLoginRedirection,
  plate,
  getAdditionalExpensesSalePost,
  isFoundPlate,
  onContinue,
  negotiatePercentage,
  setNegotiatePercentage,
  isStep1Valid,
  isStep2Valid
}: PriceProps) => {
  const navigate = useNavigate();

  const [prices, setPrices] = useState({
    retake: '0',
    publication: '0',
    sale: '0',
  });
  const [initialSuggestedLoaded, setInitialSuggestedLoaded] = useState<boolean>(false);
  const [isNegotiatePrice, setIsNegotiatePrice] = useState<YesNoTypes>("SI");
  const [carPrice, setCarPrice] = useState<string>("0");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorPercentageMessage, setErrorPercentageMessage] = useState<string>("");
  const [notSuggestedPrice, setNotSuggestedPrice] = useState<boolean>(false);
  const [localPercentage, setLocalPercentage] = useState<string>("10");
  const isContinueDisabled = !isStep1Valid || !isStep2Valid;



useEffect(() => {
  if (price && price !== "0") {
    setCarPrice(price);
  } else {
    setCarPrice("");
  }
}, [price]);
  useEffect(() => {
    if (negotiatePercentage !== undefined && negotiatePercentage !== null) {
      setLocalPercentage(negotiatePercentage.toString());
    }
  }, [negotiatePercentage]);

  useEffect(() => {
    setIsNegotiatePrice(negotiatePrice ? "SI" : "NO");
  }, [negotiatePrice]);

  useEffect(() => {
    if (suggestedPrices && !initialSuggestedLoaded) {
      
      if (suggestedPrices.sale && suggestedPrices.sale !== "0") {
        setPrices({
          retake: addPointsInText(suggestedPrices.retake || '0'),
          publication: addPointsInText(suggestedPrices.publication || '0'),
          sale: addPointsInText(suggestedPrices.sale || '0')
        });
        const parsedSale = removePointsInText(suggestedPrices.sale);
        setCarPrice(price);
        setPrice?.(price);
      }
      setInitialSuggestedLoaded(true);
    }
  }, [suggestedPrices, setPrice, initialSuggestedLoaded]);


useEffect(() => {
  if ((!price || price === "0") && suggestedPrices && !notSuggestedPrice) {
    setPrices({
      retake: addPointsInText(suggestedPrices.retake || '0'),
      publication: addPointsInText(suggestedPrices.publication || '0'),
      sale: addPointsInText(suggestedPrices.sale || '0')
    });
  }
}, [suggestedPrices, price, notSuggestedPrice]);


  const formatNumber = (num: number): string => addPointsInText(num.toString());
  const parsePrice = (value: string): number =>
    parseInt(removePointsInText(value), 10) || 0;

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    setCarPrice(value);
    setNotSuggestedPrice(true); // Marcar que se editó manualmente
    setErrorMessage("");
    const parsedValue = parseInt(value, 10);
    //getAdditionalExpensesSalePost?.(parsedValue);
    setPrice?.(value);
  };

  const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    const limitedValue = value ? Math.min(parseInt(value), 100).toString() : "";
    setLocalPercentage(limitedValue);
    setNegotiatePercentage?.(limitedValue);
    if (limitedValue === "0" && isNegotiatePrice === "SI") {
      setErrorPercentageMessage("El porcentaje no puede ser cero");
    } else {
      setErrorPercentageMessage("");
    }
  };

  const handleNegotiableChange = (value: boolean) => {
    setIsNegotiatePrice(value ? "SI" : "NO");
  };


  const applySuggestedPrice = () => {
    if (prices.sale && prices.sale !== "0") {
      const suggestedValue = removePointsInText(prices.sale);
      setCarPrice(suggestedValue);
      setPrice?.(suggestedValue);
      setNotSuggestedPrice(false); 
    }
  };

  const getPriceCategory = (): string => {
    const numPrice = parseInt(carPrice || "0");
    if (prices.retake && numPrice < parseInt(removePointsInText(prices.retake))) return "good";
    if (prices.publication && numPrice > parseInt(removePointsInText(prices.publication))) return "expensive";
    return "fair";
  };

  const getIndicatorPosition = (): number => {
    const numPrice = parseInt(carPrice || "0");
    const minPrice = parseInt(removePointsInText(prices.retake));
    const mediumPrice = parseInt(removePointsInText(prices.sale));
    const maxPrice = parseInt(removePointsInText(prices.publication));
    if (!minPrice || !mediumPrice || !maxPrice) return 50;
    if (numPrice === mediumPrice) return 50;
    if (numPrice < mediumPrice) {
      const rangeToMedium = mediumPrice - minPrice;
      const position = ((numPrice - minPrice) / rangeToMedium) * 50;
      return Math.max(0, Math.min(50, position));
    } else {
      const rangeFromMedium = maxPrice - mediumPrice;
      const position = 50 + ((numPrice - mediumPrice) / rangeFromMedium) * 50;
      return Math.min(100, position);
    }
  };

  const handleContinue = () => {
    let errorPercentage = false;
    let errorPrice = false;
  
    // Validar porcentaje
    if (isNegotiatePrice === "SI" && parseInt(localPercentage || "0") === 0) {
      setErrorPercentageMessage("El porcentaje no puede ser cero");
      errorPercentage = true;
    } else {
      setErrorPercentageMessage("");
    }
    
    // Validar precio
    if (parseInt(carPrice || "0") === 0) {
      setErrorMessage("El precio no puede ser cero");
      errorPrice = true;
    } else {
      setErrorMessage("");
    }
    
    // Si alguna validación falla, retornamos (los mensajes ya se actualizaron)
    if (errorPercentage || errorPrice) {
      return;
    }
    
    // Si ambas validaciones pasan, continuamos
    if (isNegotiatePrice === "NO") {
      setNegotiatePercentage('0');
    } else {
      setNegotiatePercentage(localPercentage);
    }
    setIsNegotiate(isNegotiatePrice === "SI");
    setPrice(carPrice.replaceAll(".", ""));
    navigate('/sell/detail');
    onContinue?.();
  };
  

  return (
    <div>
      <div className={styles.priceSection}>
        <div className={styles.priceContainer}>
          {suggestedPrices?.sale && suggestedPrices.sale !== "0" && (
            <div className={styles.suggestedPrice}>
              <div>
                <h3>Precio sugerido ${prices.sale}</h3>
                <p>Valor en el mercado desde {prices.retake} hasta {prices.publication}</p>
              </div>
            </div>
          )}

          <div className={styles.priceInput}>
            <label>Ingresa el precio de venta</label>
            <div className={styles.inputWithButton}>
              <input
                type="text"
                value={formatNumber(parsePrice(carPrice))}
                onChange={handlePriceChange}
                placeholder="Ingresa el precio"
              />
              {suggestedPrices?.sale && suggestedPrices.sale !== "0" && (
                <button
                  className={styles.applySuggestedButton}
                  onClick={applySuggestedPrice}
                >
                  Aplicar sugerido
                </button>
              )}
            </div>
            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
          </div>

          <div className={styles.negotiationSection}>
            <h3>¿Estás dispuesto a negociar?</h3>
            <div className={styles.radioGroup}>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="negotiable"
                  checked={isNegotiatePrice === "SI"}
                  onChange={() => handleNegotiableChange(true)}
                />
                <span>Sí</span>
              </label>
              <label className={styles.radioLabel}>
                <input
                  type="radio"
                  name="negotiable"
                  checked={isNegotiatePrice === "NO"}
                  onChange={() => handleNegotiableChange(false)}
                />
                <span>No</span>
              </label>
            </div>

            {isNegotiatePrice === "SI" && (
              <div className={styles.percentageInput}>
                <label>Indica el porcentaje de negociación</label>
                <div className={styles.inputWithSymbol}>
                  <input
                    type="text"
                    value={localPercentage}
                    onChange={handlePercentageChange}
                    placeholder="Porcentaje"
                    maxLength={3}
                  />
                  <span className={styles.percentSymbol}>%</span>
                </div>
                {errorPercentageMessage && (
                  <p className={styles.errorMessage}>{errorPercentageMessage}</p>
                )}
              </div>
            )}
          </div>
        </div>

                {suggestedPrices?.sale && suggestedPrices.sale !== "0" ? (
          <div className={styles.marketPriceSection}>
            <h3>Precios del mercado</h3>
            <div className={styles.marketPriceInfo}>
            <div className={styles.indicators}>
  <span className={styles.goodPrice}>
    <img 
      src={images.checkVerde} 
      alt="Buen precio" 
      className={styles.priceIcon}
      style={{ width: '18px', height: '18px' }}
    />
    Buen precio
  </span>
  <span className={styles.fairPrice}>
    <img 
      src={images.checkAmarillo} 
      alt="Precio justo" 
      className={styles.priceIcon}
      style={{ width: '18px', height: '18px' }}
    />
    Precio justo
  </span>
  <span className={styles.highPrice}>
    <img 
      src={images.checkRojo} 
      alt="Precio elevado" 
      className={styles.priceIcon}
      style={{ width: '18px', height: '18px' }}
    />
    Precio elevado
  </span>
</div>
              <div className={styles.priceBar}>
                <div className={styles.priceBarInner}>
                  <div
                    className={styles.pricePointer} 
                    style={{ left: `${getIndicatorPosition()}%` }}
                  />
                </div>
              </div>
              <div className={styles.suggestedPriceDisplay}>
                <h3>${prices.sale}</h3>
                <p>Precio Sugerido</p>
              </div>
              <p className={styles.priceInfo}>
                El valor que elijas para tu vehículo influirá en cómo se posiciona dentro de la plataforma.
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.calculatingPriceContainer}>
            <img src={require('../../../assets/images/NewLinzeCalculo.png')} alt="Linze calculando" className={styles.calculatingImage} />
          </div>
        )}
              </div>

      <div className={styles.buttonContainer}>
        {/* Mensajes de validación */}
      {!isStep1Valid && (
        <div className={styles.validationError}>
         <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#ff0000">
  <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
</svg>
          Completa el <strong>Paso 1 </strong> (Información básica) para continuar
        </div>
      )}
      
      {!isStep2Valid && isStep1Valid && ( // Solo muestra esto si el Paso 1 está OK
        <div className={styles.validationError}>
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#ff0000">
              <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
          </svg>
        Sube las fotos obligatorias en el <strong>Paso 2</strong> (Fotos y videos)
        </div>
      )}
        <Button
          onPress={handleContinue}
          title="Continuar"
          primary
          className={styles.submitButton}
          disabled={isContinueDisabled}
        />
      </div>
    </div>
  );
};

export default Price;
